import { SelectorBase } from "../../Config/SelectorBase";
import { IActivityModel } from '../Activity/Activity';
import { IPortalState } from './PortalState';
import { IActivityCategoryModel } from '../ActivityCategory/ActivityCategory';
import { IActivityThemeModel } from '../ActivityTheme/ActivityTheme';



/* Selector represents the data 
 * that needs to be displayed no update or delete should here
 * All of the updates and delete (data changes) should 
 * be done via action in the reducer
 */
 export class PortalStateSelector extends SelectorBase{
    public static getPortalState(): IPortalState{
        const session = super.getDataSource();
        const portalState :IPortalState= session.PortalState.withId("0");
        return portalState; 
    } 
    public static getSelectedActivity(): IActivityModel | undefined{
        if(this.getPortalState()){ 
        const activity : IActivityModel = this.getPortalState().SelectedActivity

         return activity;
        }
        return undefined
     }
    public static getSelectedTheme(): IActivityThemeModel | undefined{
        if(this.getPortalState()){ 
         const theme : IActivityThemeModel = this.getPortalState().SelectedTheme
         return theme;
        }
        return undefined
     }
    public static getSelectedCategory(): IActivityCategoryModel | undefined{
        if(this.getPortalState()){  
        const category : IActivityCategoryModel = this.getPortalState().SelectedCategory
         return category;
        }
        return undefined
     }
     public static getActivitiesWithSameTitle(){
         const session = super.getDataSource()
         const activities = session.Activity.all().toModelArray();    
         const SelectedActivity = this.getSelectedActivity();
         if(SelectedActivity !== undefined){
        return activities.filter(act => act.courseTitle === SelectedActivity.courseTitle && act.fiuNo !== SelectedActivity.fiuNo)
         }
         return undefined
     }
 }


// WEBPACK FOOTER //
// ./src/Entities/PortalState/PortalState.Selector.ts